import { render, staticRenderFns } from "./RateSocialSecurityTable.vue?vue&type=template&id=e74a733a&scoped=true"
import script from "./RateSocialSecurityTable.vue?vue&type=script&lang=js"
export * from "./RateSocialSecurityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74a733a",
  null
  
)

export default component.exports